import React from 'react';
import {Box} from "@mui/material";
import {IconContext} from "react-icons";
import {IWarehouseParentProduct} from "../../../../../utils/interfaces/my_warehouse/IWarehouseParentProduct";


const useMyWarehouseParentProductCustomCellRenderer = (row: IWarehouseParentProduct, theme: any) => {


    const getIconsForCustomField = (row: IWarehouseParentProduct, theme: any) => {
        const iconColor = theme.palette.primary.main;

        return (
            // <BsPeople
            //
            // />
            null
        );
    };

    const renderIcons = () => {
        const icons = getIconsForCustomField(row, theme);
        return (
            <IconContext.Provider value={{size: "1.3rem"}}>
                <Box display="flex" sx={{gap: 0.5}}>
                    <span>{icons}</span>
                </Box>
            </IconContext.Provider>
        );
    };

    return {renderIcons};
};

export default useMyWarehouseParentProductCustomCellRenderer;